import _Vue from "vue";
import { ROUTER_HELPER } from "../../common/router-helper.contstants";
import { ROUTER_OPTION, ROUTER_DYNAMIC_PATH, ROUTER_DATA_STORAGE } from "../../common/router-helper.contstants";
import { IRouteOption, IRoutePayload, IRouterHelper } from "../../models/router";
import { compareObjectAndApplyNew, convertObjectKeyToArrayString, deepCopy, getMainTabFromPath } from "../../utils/util";
import { storeModules, IRootState } from "../../store";
import { COMMON_ROUTER_MANAGER } from "../../store/types";
import { LocalforageWrapper } from "../../utils/localforage-wrapper";
import propertyEditTypesStore from "../../store/property/edit/property-edit-types.store";
import personEditStoreTypes from "../../store/person/edit/define-types.store";
import personDetailStoreTypes from "../../store/person/detail/define-types.store";
import demandTypesStore from "../../store/demand/edit/demand-types.store";
import agendaEditType from "../../store/agenda/edit/edit.types.store";
import taskTypesStore from "../../store/task/edit/task-types.store";
import RouterHelper from "../../models/router/router-helper.model";
import { PropertyEditModule } from "../../store/property/edit";
// import { PropertyConfigModule } from "../../store/property/config";
import { PersonListModule } from "../../store/person/list";
// import { PersonConfigurationModule } from "../../store/person/configuration";
import { PersonDetailModule } from "../../store/person/detail";
import { DemandEditModule } from "../../store/demand/edit";
import moduleConstant from "../../common/module-constant";
import { default as JSONPath } from 'fast-json-patch';
import { RouteConfig } from "vue-router";

const RouterPlugin = {
    install(Vue: typeof _Vue, options?: Object | {}) {
        Vue.prototype.$addChildRoute = async function (payload: {
            routerModule: string,
            newRouter: { type: string, action: string },
            routeOption?: IRouteOption,
            routePayload?: IRoutePayload,
        }): Promise<any> {
            let vm = this as any;
            const { routerModule, newRouter, routeOption, routePayload } = payload;
            let { routes } = vm.$router.options;

            // get router module
            let route = routes.find(r => r.path.includes(routerModule));

            // get children of module with current name
            let routeDataChild = vm.$findRouteInTreeRoute(route, vm.$route.name, 'name'); // add route to child of current router

            const routeSupport = vm.$getRouteOption(newRouter);

            // if not found the route option => we not support this action
            if (routeSupport == undefined) {
                return null;
            }

            let routeOp = routeOption ? compareObjectAndApplyNew(routeOption, routeSupport.options) : routeSupport.options;
            // routeOp.meta.moduleType = vm.$getModuleType(routerModule);

            // check router exist
            let newRoute = {
                path: vm.$getPathNewRoute(newRouter, routePayload),
                name: vm.$getNameNewRoute(newRouter, routePayload),
                ...routeOp,
            };

            if (routeDataChild.children == undefined) {
                routeDataChild.children = [];
            }

            const routeExist = routeDataChild.children.find(r => r.name == newRoute.name || r.path == newRoute.path);

            if (routeExist) {
                return Promise.resolve(routeExist);
            } else {
                routeDataChild.children.push(newRoute);
                vm.$router.addRoutes([route]);
                // LocalforageWrapper.setItem('Routes', { router: deepCopy(vm.$router.options.routes) });
                return Promise.resolve(newRoute);
            }
        };

        Vue.prototype.$pushToNewRouter = async function (payload: {
            from: { type: string, action: string },
            newRouter: { type: string, action: string },
            routeOption?: IRouteOption,
            routePayload?: IRoutePayload,
            cache?: boolean
        }) {
            let vm = this as any;
            const { newRouter, routeOption, routePayload, from } = payload;
            const mainModule = getMainTabFromPath(vm.$router.currentRoute.path);
            const route = await vm.$addChildRoute({ routerModule: mainModule, newRouter, routeOption, routePayload });
            const cache = payload.cache === undefined ? true : payload.cache;
            if (cache) {
                const routeDataSave = new RouterHelper({
                    name: vm.$route.name,
                    path: vm.$route.path,
                    query: vm.$route.query ? vm.$route.query : {},
                    params: vm.$route.params ? vm.$route.params : {},
                    type: from.type,
                    action: from.action
                });
                vm.$store.commit(`${storeModules.Common}/${COMMON_ROUTER_MANAGER.UPDATE_LIST_ROUTER}`, { route: routeDataSave });
                vm.$saveDataRouterToLocalStorage({ from });
            }
            if (route) {
                console.log('pushToNewRouter', route);
                const newRoutePayload = {
                    params: routePayload && routePayload.params ? routePayload.params : {},
                    query: {
                        ...(routePayload && routePayload.query ? routePayload.query : {}),
                        fromAction: from.action,
                        fromType: from.type
                    }
                }
                vm.$router.push({
                    name: route.name,
                    ...newRoutePayload
                });
            }
        }

        Vue.prototype.$getPathNewRoute = function (
            newRouter: { type: string, action: string },
            routePayload?: IRoutePayload
        ): string {
            let vm = this as any;
            let strArray = vm.$router.currentRoute.path.includes(ROUTER_DYNAMIC_PATH) ? [newRouter.type] : [ROUTER_DYNAMIC_PATH, newRouter.type];
            const arrParams = convertObjectKeyToArrayString(routePayload && routePayload.params ? routePayload.params : {});
            strArray.push(newRouter.action);
            Array.prototype.push.apply(strArray, arrParams);
            return strArray.join('/');
        }

        Vue.prototype.$getNameNewRoute = function (
            newRouter: { type: string, action: string },
            routePayload?: IRoutePayload
        ): string {
            let vm = this as any;
            let strArray = [vm.$router.currentRoute.name, `${newRouter.type}-${newRouter.action}`];
            return strArray.join('-');
        }

        Vue.prototype.$findRouteInTreeRoute = function (element: any, matchingString: string, fieldName: string) {
            let vm = this as any;
            if (element[fieldName] == matchingString) {
                return element;
            } else if (element.children && element.children != null) {
                let i;
                let result = null;
                let arr = element.children.filter(item => item != null);
                for (i = 0; result == null && i < arr.length; i++) {
                    result = vm.$findRouteInTreeRoute(element.children[i], matchingString, fieldName);
                }
                return result;
            }
            return null;
        }

        Vue.prototype.$routerBack = async function (payload?: { from: { type: string, action: string } }) {

            console.log('router-helper routerBack');

            let vm = this as any;
            const { from } = payload;

            // back route is lastest route in router list state.
            const routerList = vm.$store.getters[`${storeModules.Common}/${COMMON_ROUTER_MANAGER.GET_LIST_ROUTER}`] as IRouterHelper[];

            const lastestRoute = routerList[routerList.length - 1];
            if (lastestRoute) {
                await vm.$loadDataCurrentRoute();
                await vm.$removeDataCurrentRoute();
                vm.$router.push({
                    name: lastestRoute.name,
                    params: {
                        ...lastestRoute.params,
                    },
                    query: lastestRoute.query
                });
                vm.$autoDefineStoreModule({ from, to: { type: lastestRoute.type, action: lastestRoute.action } });
            } else {
                vm.$router.back();
            }
        }

        Vue.prototype.$clearRouteDynamic = function () {
            const vm = this as any;
            LocalforageWrapper.removeItem(ROUTER_DATA_STORAGE);
            vm.$store.commit(`${storeModules.Common}/${COMMON_ROUTER_MANAGER.CLEAR_LIST_ROUTER}`);
        }

        Vue.prototype.$saveDataRouterToLocalStorage = async function (payload: { from: { type: string, action: string } }) {
            const vm = this as any;
            const { from } = payload;
            const routerList = vm.$store.getters[`${storeModules.Common}/${COMMON_ROUTER_MANAGER.GET_LIST_ROUTER}`] as IRouterHelper[];

            const routeListSave = deepCopy(routerList);
            const routeSave = routeListSave[routeListSave.length - 1];
            switch (from.type) {
                case ROUTER_HELPER.TYPE.PROPERTY:
                    if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                        // routeSave.save.PropertyConfiguration = vm.$store.getters[`${storeModules.PropertyConfiguration}/config`];
                        routeSave.save.Property = vm.$store.getters[`${storeModules.PropertyEdit}/property`];
                        routeSave.save.OriginalProperty = vm.$store.getters[`${storeModules.PropertyEdit}/originalProperty`];
                        routeSave.save.PropertySubcategory = vm.$store.getters[`${storeModules.PropertyEdit}/propertySubcategory`];
                        routeSave.save.PropertyDescription = vm.$store.getters[`${storeModules.PropertyEdit}/propertyDescription`];
                    }
                    break;
                case ROUTER_HELPER.TYPE.CLIENT:
                    if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                        routeSave.save.PersonModel = vm.$store.getters[`${storeModules.PersonEdit}/personModel`];
                        routeSave.save.OriginPersonModel = vm.$store.getters[`${storeModules.PersonEdit}/originPersonModel`];
                    }

                    if (from.action == ROUTER_HELPER.ACTION.VIEW) {
                        routeSave.save.PersonModel = vm.$store.getters[`${storeModules.PersonDetail}/personModel`];
                    }
                    break;
                case ROUTER_HELPER.TYPE.DEMAND:
                    if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                        routeSave.save.Demand = vm.$store.getters[`${storeModules.DemandEdit}/demand`];
                        routeSave.save.DemandOrigin = vm.$store.getters[`${storeModules.DemandEdit}/demandOrigin`];
                        routeSave.save.DemandConfig = vm.$store.getters[`${storeModules.DemandEdit}/config`];
                    }
                    break;
                case ROUTER_HELPER.TYPE.AGENDA:
                    if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                        routeSave.save.Appointment = vm.$store.getters[`${storeModules.AgendaEdit}/appointment`];
                        routeSave.save.AppointmentOrigin = vm.$store.getters[`${storeModules.AgendaEdit}/appointmentOrigin`];
                        routeSave.save.CurrentComment = vm.$store.getters[`${storeModules.AgendaEdit}/currentComment`];
                    }
                    break;
                case ROUTER_HELPER.TYPE.TASK:
                    if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                        routeSave.save.TaskModel = vm.$store.getters[`${storeModules.TaskEdit}/taskModel`];
                        routeSave.save.OriginTaskModel = vm.$store.getters[`${storeModules.TaskEdit}/originTaskModel`];
                    }
                    break;
            }
            let routerListStorage = await LocalforageWrapper.getItem(ROUTER_DATA_STORAGE) as IRouterHelper[];
            if (routerListStorage) {
                routerListStorage.push(routeSave);
            } else {
                routerListStorage = [routeSave];
            }
            LocalforageWrapper.setItem(ROUTER_DATA_STORAGE, routerListStorage);
        }

        Vue.prototype.$loadDataCurrentRoute = async function () {

            const vm = this as any;
            const routeDataStorage = await LocalforageWrapper.getItem(ROUTER_DATA_STORAGE) as IRouterHelper[];
            const lastRoute = routeDataStorage[routeDataStorage.length - 1];
            if (lastRoute && lastRoute.save) {
                const routeClone = deepCopy(lastRoute) as IRouterHelper;
                switch (routeClone.type) {
                    case ROUTER_HELPER.TYPE.PROPERTY:
                        if (routeClone.action == ROUTER_HELPER.ACTION.EDIT) {
                            // vm.$store.commit(`${storeModules.PropertyConfiguration}/${propertyConfigTypesStore.Set.PROPERTY_CONFIGURATIONS}`, routeClone.save.PropertyConfiguration);
                            vm.$store.commit(`${storeModules.PropertyEdit}/${propertyEditTypesStore.Set.PROPERTY}`, routeClone.save.Property);
                            vm.$store.commit(`${storeModules.PropertyEdit}/${propertyEditTypesStore.Set.ORIGIN_PROPERTY}`, routeClone.save.OriginalProperty);
                            vm.$store.commit(`${storeModules.PropertyEdit}/${propertyEditTypesStore.Set.PROPERTY}`, routeClone.save.Property);
                            vm.$store.commit(`${storeModules.PropertyEdit}/${propertyEditTypesStore.Set.PROPERTY_SUBCATEGORY}`, routeClone.save.PropertySubcategory);
                            vm.$store.commit(`${storeModules.PropertyEdit}/${propertyEditTypesStore.Set.PROPERTY_DESCRIPTION}`, routeClone.save.PropertyDescription);
                        }

                        break;
                    case ROUTER_HELPER.TYPE.CLIENT:
                        if (routeClone.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$store.commit(`${storeModules.PersonEdit}/${personEditStoreTypes.Set.PERSON_MODEL}`, routeClone.save.PersonModel);
                            vm.$store.commit(`${storeModules.PersonEdit}/${personEditStoreTypes.Set.ORIGIN_PERSON_MODEL}`, routeClone.save.OriginPersonModel);
                        }

                        if (routeClone.action == ROUTER_HELPER.ACTION.VIEW) {
                            vm.$store.commit(`${storeModules.PersonDetail}/${personDetailStoreTypes.Set.PERSON_MODEL}`, routeClone.save.PersonModel);
                        }
                        break;
                    case ROUTER_HELPER.TYPE.DEMAND:
                        if (routeClone.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$store.commit(`${storeModules.DemandEdit}/${demandTypesStore.Set.DEMAND}`, routeClone.save.Demand);
                            vm.$store.commit(`${storeModules.DemandEdit}/${demandTypesStore.Set.DEMANDORIGIN}`, routeClone.save.DemandOrigin);
                            vm.$store.commit(`${storeModules.DemandEdit}/${demandTypesStore.Set.CONFIG}`, routeClone.save.DemandConfig);
                        }
                        break;
                    case ROUTER_HELPER.TYPE.AGENDA:
                        if (routeClone.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$store.commit(`${storeModules.AgendaEdit}/${agendaEditType.Set.APPOINTMENT}`, routeClone.save.Appointment);
                            vm.$store.commit(`${storeModules.AgendaEdit}/${agendaEditType.Set.APPOINTMENTORIGIN}`, routeClone.save.AppointmentOrigin);
                            vm.$store.commit(`${storeModules.AgendaEdit}/${agendaEditType.Set.CURRENT_COMMENT}`, routeClone.save.CurrentComment);
                        }
                        break;
                    case ROUTER_HELPER.TYPE.TASK:
                        if (routeClone.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$store.commit(`${storeModules.TaskEdit}/${taskTypesStore.Set.TASK_MODEL}`, routeClone.save.TaskModel);
                            vm.$store.commit(`${storeModules.TaskEdit}/${taskTypesStore.Set.ORIGIN_TASK_MODEL}`, routeClone.save.OriginTaskModel);
                        }
                        break;
                }
            }
        }

        Vue.prototype.$removeDataCurrentRoute = async function () {

            const vm = this as any;

            // remove in state
            vm.$store.commit(`${storeModules.Common}/${COMMON_ROUTER_MANAGER.REMOVE_LIST_ROUTER}`);

            // remove in storage
            const routerListStorage = await LocalforageWrapper.getItem(ROUTER_DATA_STORAGE) as IRouterHelper[];
            routerListStorage.pop();
            LocalforageWrapper.setItem(ROUTER_DATA_STORAGE, routerListStorage);
        }

        Vue.prototype.$getRouteOption = function (newRoute: { type: string, action: string }) {
            return ROUTER_OPTION.find(item => item.types.findIndex(t => t == newRoute.type) != -1 && item.actions.findIndex(a => a == newRoute.action) != -1);
        }

        Vue.prototype.$autoDefineStoreModule = function (payload: {
            from?: { type: string, action: string },
            to?: { type: string, action: string },
        }): void {
            const vm = this as any;
            const { from, to } = payload;
            if (from.type != to.type && from.action != to.action) {
                if (from) {
                    // unregister 
                    switch (from.type) {
                        case ROUTER_HELPER.TYPE.PROPERTY:
                            if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                                vm.$unRegisterModule(storeModules.PropertyEdit);
                                // vm.$unRegisterModule(storeModules.PropertyConfiguration);
                            }
                            break;
                        case ROUTER_HELPER.TYPE.CLIENT:
                            if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                                vm.$unRegisterModule(storeModules.PersonEdit);
                                vm.$unRegisterModule(storeModules.PersonConfiguration);
                            }
                            if (from.action == ROUTER_HELPER.ACTION.VIEW) {
                                vm.$unRegisterModule(storeModules.PersonDetail);
                            }
                            break;
                        case ROUTER_HELPER.TYPE.DEMAND:
                            if (from.action == ROUTER_HELPER.ACTION.EDIT) {
                                vm.$unRegisterModule(storeModules.DemandEdit);
                                vm.$unRegisterModule(storeModules.DemandConfiguration);
                            }
                            if (from.action == ROUTER_HELPER.ACTION.VIEW) {
                                vm.$unRegisterModule(storeModules.DemandDetail);
                            }
                            break;
                        default: break;
                    }
                }

                // register 
                switch (to.type) {
                    case ROUTER_HELPER.TYPE.PROPERTY:
                        if (to.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$registerModule(storeModules.PropertyEdit, new PropertyEditModule());
                            // vm.$registerModule(storeModules.PropertyConfiguration, new PropertyConfigModule());
                        }
                        break;
                    case ROUTER_HELPER.TYPE.CLIENT:
                        if (to.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$registerModule(storeModules.Person, new PersonListModule<IRootState>())
                            // vm.$registerModule(storeModules.PersonConfiguration, new PersonConfigurationModule<IRootState>())
                        }
                        if (to.action == ROUTER_HELPER.ACTION.VIEW) {
                            vm.$registerModule(storeModules.PersonDetail, new PersonDetailModule())
                        }
                        break;
                    case ROUTER_HELPER.TYPE.DEMAND:
                        if (to.action == ROUTER_HELPER.ACTION.EDIT) {
                            vm.$registerModule(storeModules.DemandEdit, new DemandEditModule<IRootState>());
                        }
                        break;
                    default: break;
                }
            }
        }

        //#region register module
        Vue.prototype.$registerModule = function (namespace, module) {
            const vm = this as any;
            const store = vm.$store;
            if (!(store && store.state && store.state[namespace])) {
                console.log(`registry module: ${namespace}`);
                vm.$store.registerModule(namespace, module)
            } else {
                console.log(`reusing module: ${namespace}`);
            }
        }

        Vue.prototype.$unRegisterModule = function (namespace) {
            const vm = this as any;
            const store = vm.$store;
            if (store && store.state && store.state[namespace]) {
                store.unregisterModule(namespace);
                console.log(`unregister module: ${namespace}`);
            } else {
                console.log(`module had already unregister: ${namespace}`);
            }
        }
        //#endregion

        Vue.prototype.$getModuleType = function (mainModule: string) {
            switch (mainModule) {
                case ROUTER_HELPER.TYPE.AGENDA:
                    return moduleConstant.Agenda;
                case ROUTER_HELPER.TYPE.CLIENT:
                    return moduleConstant.Person;
                case ROUTER_HELPER.TYPE.PROPERTY:
                    return moduleConstant.Object;
                case ROUTER_HELPER.TYPE.DEMAND:
                    return moduleConstant.Demand;
                case ROUTER_HELPER.TYPE.PROJECT:
                    return moduleConstant.Object;
                default: return 0;
            }
        }

        Vue.prototype.$checkRouteIsOpen = function (type: string, action: string) {
            const vm = this as any;
            const routerList = vm.$store.getters[`${storeModules.Common}/${COMMON_ROUTER_MANAGER.GET_LIST_ROUTER}`] as IRouterHelper[];
            const routeFind = routerList.find(item => item.type == type && item.action == action);
            if (routeFind) {
                return true;
            }
            return false;
        }

        Vue.prototype.$countRouteIsOpen = function (type: string, action: string) {
            const vm = this as any;
            const routerList = vm.$store.getters[`${storeModules.Common}/${COMMON_ROUTER_MANAGER.GET_LIST_ROUTER}`] as IRouterHelper[];
            const routeCount = routerList.filter(item => item.type == type && item.action == action);
            return routeCount.length;
        }

        Vue.prototype.$loadRouterFromStorage = async function () {
            const vm = this as any;
            const routesOriginal = await LocalforageWrapper.getItem('RoutesOriginal') as RouteConfig[];
            const routes = await LocalforageWrapper.getItem('Routes') as RouteConfig[];
            const routesInit = vm.$router.options.routes;
            if (routesOriginal && routes) {
                const compare = JSONPath.compare(routesInit, routesOriginal);
                if (!compare) {
                    vm.$router.addRoutes(routes);
                }
            }
        }
    }
};

export default RouterPlugin;

declare module 'vue/types/vue' {
    interface Vue {

        $getPathNewRoute: (newRouter: { type: string, action: string }, routePayload?: IRoutePayload) => string;

        $getNameNewRoute: (newRouter: { type: string, action: string }, routePayload?: IRoutePayload) => string;

        $addChildRoute: (payload: {
            routerModule: string,
            newRouter: { type: string, action: string },
            routeOption?: IRouteOption,
            routePayload?: IRoutePayload,
        }) => Promise<any>;

        $pushToNewRouter: (payload: {
            from: { type: string, action: string },
            newRouter: { type: string, action: string },
            routeOption?: IRouteOption,
            routePayload?: IRoutePayload,
            cache?: boolean
        }) => Promise<any>;

        $findRouteInTreeRoute: (element: any, matchingString: string, fieldName: string) => any;

        $getRouteOption: (newRoute: { type: string, action: string }) => any;

        $routerBack: (payload: { from: { type: string, action: string } }) => void;

        $saveDataRouterToLocalStorage: (payload: { from: { type: string, action: string } }) => void;

        $removeDataCurrentRoute: (level: number) => Promise<void>;

        $loadDataCurrentRoute: () => Promise<void>;

        $clearRouteDynamic: () => void;

        $autoDefineStoreModule: (payload: { from?: { type: string, action: string }, to?: { type: string, action: string } }) => void;

        $registerModule: (namespace, module) => void;

        $unRegisterModule: (namespace) => void;

        $getModuleType: (mainModule: string) => number;

        $checkRouteIsOpen: (type: string, action: string) => boolean;

        $countRouteIsOpen: (type: string, action: string) => number;

        $loadRouterFromStorage: () => Promise<void>;

    }
}